import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Joi from 'joi-full';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import Form from '../components/SubscriptionChargeForm';
import { syncValidateData } from '../../../common/validator';
import { getSubscriptionId } from '../reducers/subscription';
import { createSubscriptionCharge } from '../actions';

const FORM = 'subscriptionChargeForm';
const extendedJoi = Joi.extend({
  base: Joi.number(),
  name: 'number',
  language: {
    maxMoney: 'must be less than or equal to {{q}}',
  },
  rules: [
    {
      name: 'maxMoney',
      params: {
        q: Joi.number().required(),
      },
      validate(params, value, state, options) {
        if (value > params.q * 100) {
          return this.createError('number.maxMoney', { v: value, q: params.q }, state, options);
        }

        return value;
      },
    },
  ],
});

const schema = Joi.object().keys({
  price: extendedJoi.number().greater(0).maxMoney(100000).required(),
  desc: Joi.string().optional().allow(null, ''),
});

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: FORM,
  validate,
  initialValues: { price: 0 },
});

const addHandlers = withHandlers({
  processCharge: props => data => props.createSubscriptionCharge(props.subscriptionId, data)
    .then(() => props.reset()),
});

const mapStateToProps = state => ({
  subscriptionId: getSubscriptionId(state),
});

const mapDispatchToProps = {
  createSubscriptionCharge,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  form,
  addHandlers,
)(Form);
